<template>
  <div class="record-detail-wrapper" v-wechat-title="title">
    <!-- 当前用户为患者&&订单状态为1时才显示倒计时 -->
    <div class="payment-countdown" v-if="dataDone && formData.order_status == 1">支付倒计时
      <van-count-down class="countdown" :time="leftTime" @finish="changeOrderStatus" />，72小时内未支付，订单将自动取消</div>
    <div class="record-back" :class="{'questionnaire': detailType == 2, 'top': formData.order_status == 1}"></div>
    <div class="record-main" v-if="dataDone">
      <div class="doc-card" v-if="detailType != 1">
        <div class="avatar"><img :src="formData.avatar"></div>
        <div class="doc-info">
          <div class="name">{{formData.doc_username}}<span>{{formData.title | jobTitleFilter}}</span></div>
          <div class="job">{{formData.p_dep_title}} | {{formData.dep_title}}</div>
        </div>
        <div class="push-to-doc" v-if="pushToDoc"><button class="push-to" @click="pushTo(formData)">
            推送给医生
          </button></div>
      </div>
      <!-- 病历页详情 -->
      <template v-if="detailType == 3">
        <prescription-paper :script-data="formData" :role="userInfo.role" :is-pay="(formData.order_status == 3 || formData.order_status == 4) ? true : false"
          :from="'record'" />
        <!-- 患者需判断订单状态显示对应操作 -->
        <div class="patient-script-control" :class="{'has-pay-button': formData.order_status == 1}">
          <address-picker :address-data="addressData" :read-only="formData.order_status != 1 ? true : false" v-if="formData.order_status != 2"
            @picked="confirmAddress" />
          <div class="script-price-container">
            <div class="normal-price">
              <!--
              <div class="price-item">
                <div class="type">药材费</div>
                <div class="price">¥ {{formData.normalPrice.toFixed(2)}}</div>
              </div>
              -->
              <!-- 处方剂型为中药饮片并且不代做膏方时才显示代煎选项 -->
              <!-- 待支付时显示选项 -->
              <div class="price-item" v-if="formData.type == 1 && parseFloat(formData.paste_price) == 0 && formData.order_status == 1">
                <div class="type">代煎药方<span>*</span></div>
                <div class="price">
                  <div class="selector">
                    <div class="selector-item" :class="{'selected': selectedDecoction == 1}" @click="selectDecoction(1)">是</div>
                    <div class="selector-item" :class="{'selected': selectedDecoction == 2}" @click="selectDecoction(2)">否</div>
                  </div>
                </div>
              </div>
              <div class="price-item" v-if="selectedDecoction == 1">
                <div class="type">代煎费用</div>
                <div class="price">¥ {{decoctionMoeny.toFixed(2)}}</div>
              </div>
              <!--
              <div class="price-item">
                <div class="type">运费</div>
                <div class="price" :class="{'zero': expressPrice == 0}">¥ {{expressPrice.toFixed(2)}}</div>
              </div>
              -->
            </div>
            <div class="total-price">
              <div class="type">共计</div>
              <div class="price">¥ {{totalPrice | int}}<span>{{totalPrice | float}}</span></div>
            </div>
          </div>
          <div class="invalid-tips" v-if="formData.order_status == 2">订单已失效，如有疑问请<a :href="`tel:${serviceNumber}`">联系喜乐医生客服</a></div>
          <div class="fixed-pay" v-if="formData.order_status == 1">
            <div class="payment-info">实付<span>¥ {{totalPrice.toFixed(2)}}</span></div>
            <button class="pay-button" @click="orderPay" :disabled="paying">去支付</button>
          </div>
          <div class="back" v-else><button class="back-button" @click="back">返回</button></div>
          <status-dialog v-if="invalidOrderShow" status-type="error" title="订单失效" sub-title="订单支付超时，感谢您的理解！" @close="invalidOrderShow = false"></status-dialog>
        </div>
        <!-- <div class="check-card" v-else>
          <div class="check-box">
            <icon icon-class="review"></icon>
            <div class="check-text">
              <h4>医生正在为您开方...</h4>
              <p>请稍后查看</p>
            </div>
          </div>
          <div class="check-back"><button class="check-back-button" @click="back">返回</button></div>
        </div> -->
      </template>
      <!-- 问诊单详情 -->
      <template v-if="detailType == 2">
        <questionnaire :form-data="formData" />
      </template>
      <!-- 首诊信息详情 -->
      <template v-if="detailType == 1">
        <first-record :form-data="formData" />
        <!-- <div class="unfinished-record" v-if="detailStatus == 1">
          <div class="unfinished-header">
            <h3>线下就诊</h3>
            <span class="date">就诊时间：{{recordCreatedTime | dateFilter}}</span>
          </div>
          <edit-first-record
            :private-id="privateId"
            :doc-id="docId"
            page="edit"
            :patient-info="patientInfo"
            @success="finishEditRecord"></edit-first-record>
        </div> -->
      </template>
      <!-- <first-record :form-data="formData" v-else-if="detailType == 1 && detailStatus == 1" /> -->
      <div class="back" v-if="showBack"><button class="back-button" @click="back">返回</button></div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .record-detail-wrapper{
    position: relative;
    min-height: 100vh;
    background: #F7F7F7;
    .payment-countdown{
      position: relative;
      width: 100%;
      height: 32px;
      background: #F5A41E;
      color: #FFF;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      z-index: 2;
      .countdown{
        color: #FFF;
        margin: 0 4px;
        font-weight: bold;
        font-size: 15px;
      }
    }
    .record-back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: @xile;
      z-index: 1;
      &.questionnaire{
        background: @wenzhen;
      }
      &.top{
        top: 32px;
      }
    }
    .record-main{
      position: relative;
      z-index: 10;
      padding: 16px 8px 0;
      .doc-card{
        padding: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #FFF;
        border-radius: 6px;
        box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
        position: relative;
        .push-to-doc{
          position:absolute;
          right: 10px;
          top:15px;
          font-size: 13px;
          width: 100px;
          height: 40px;
          .push-to{
            padding:5px 5px;
            @button-base();
            width: 100%;
            height: 32px;
            background: #F5A41E;
            font-size: 12px;
          }
        }
        .avatar{
          width: 48px;
          height: 48px;
          overflow: hidden;
          border-radius: 50%;
          flex-shrink: 0;
          img{
            width: 100%;
          }
        }
        .doc-info{
          margin-left: 12px;
          .name{
            font-size: 16px;
            line-height: 16px;
            color: @black;
            font-weight: bold;
            span{
              margin-left: 8px;
              font-size: 14px;
              color: #999;
              font-weight: normal;
            }
          }
        }
        .job{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          margin-top: 8px;
        }
      }
      .unfinished-record{
        margin-top: 12px;
        border-radius: 6px;
        overflow: hidden;
        .unfinished-header{
          padding: 20px 12px 16px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #FAFAFA;
          border-bottom: 1px solid #F3F3F3;
          h3{
            font-size: 20px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
          }
          .date{
            font-size: 14px;
            line-height: 14px;
            color: #666;
          }
        }
      }
      .back{
        padding: 24px 0 12px;
        .back-button{
          @button-base();
          width: 100%;
          height: 40px;
        }
      }
      .patient-script-control{
        &.has-pay-button{
          padding-bottom: 60px;
        }
        .script-price-container{
          margin-top: 12px;
          background: #FFF;
          border-radius: 6px;
          padding: 32px 16px;
          .normal-price{
            padding-bottom: 20px;
            .price-item{
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 29px;
              &:last-child{
                margin-bottom: 0;
              }
              .type{
                font-size: 16px;
                line-height: 16px;
                color: @black;
                font-weight: bold;
                span{
                  color: @error;
                }
              }
              .price{
                font-size: 16px;
                line-height: 16px;
                color: #666;
                font-weight: bold;
                &.zero{
                  color: #999;
                }
                .selector{
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .selector-item{
                    height: 32px;
                    padding: 0 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #E0E6E6;
                    background: #F7F7F7;
                    color: #999;
                    font-size: 14px;
                    cursor: pointer;
                    border-radius: 4px;
                    transition: all .1s;
                    &:first-child{
                    margin-right: 16px;
                    }
                    &.selected{
                      border-color: @xile;
                      background: @xile;
                      color: #FFF;
                    }
                  }
                }
              }
            }
          }
          .total-price{
            border-top: 1px solid #EEE;
            padding-top: 28px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .type{
              font-size: 20px;
              line-height: 20px;
              color: @black;
              font-weight: bold;
            }
            .price{
              font-size: 24px;
              line-height: 24px;
              color: @xile;
              font-weight: bold;
              span{
                font-size: 18px;
              }
            }
          }
        }
        .invalid-tips{
          text-align: center;
          margin-top: 24px;
          font-size: 14px;
          line-height: 14px;
          color: #999;
          a{
            color: @xile;
            text-decoration: underline;
          }
        }
        .fixed-pay{
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 48px;
          background: #FFF;
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 20;
          .payment-info{
            padding-left: 24px;
            font-size: 16px;
            color: @black;
            font-weight: bold;
            span{
              margin-left: 12px;
              font-size: 20px;
              color: @xile;
            }
          }
          .pay-button{
            @button-base();
            width: 144px;
            height: 100%;
            border-radius: 0;
          }
        }
      }
      .check-card{
        padding: 45px 16px 12px;
        background: #FFF;
        border-radius: 4px;
        margin-top: 12px;
        .check-box{
          display: flex;
          justify-content: center;
          align-items: center;
          svg{
            font-size: 44px;
          }
          .check-text{
            padding-left: 12px;
            h4{
              font-size: 17px;
              line-height: 17px;
              color: @xile;
              font-weight: normal;
            }
            p{
              margin-top: 8px;
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
          }
        }
        .check-back{
          margin-top: 40px;
          button{
            @button-base();
            @button-border();
            width: 100%;
            height: 40px;
            border-radius: 6px;
            font-size: 15px;
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  import prescriptionPaper from '@/components/Common/prescription'
  import addressPicker from '@/components/Common/addressPicker'
  import questionnaire from '@/components/Common/questionnaire'
  import firstRecord from '@/components/Common/firstRecord'
  import editFirstRecord from '@/components/Common/firstRecordEdit'
  import statusDialog from '@/components/Common/statusDialog'
  export default {
    data() {
      return {
        dataDone: false,
        detailType: parseInt(this.$route.query.type),
        formData: {},
        // 首诊信息数据
        privateId: 0,
        docId: 0,
        recordCreatedTime: new Date().getTime() / 1000,
        patientInfo: {},
        showBack: false,
        pushToDoc: false,
        // 未支付病历数据
        leftTime: 0,
        // 用户选择地址数据
        addressData: {
          address_id: null,
          name: '',
          mobile: '',
          province: '',
          city: '',
          country: '',
          region: '',
        },
        // 运费
        expressPrice: 0,
        // 是否代煎
        selectedDecoction: null,
        // 代煎费用
        decoctionMoeny: 20,
        // 防止按钮多次点击
        paying: false,
        // 订单过期弹窗
        invalidOrderShow: false,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      title() {
        switch (this.detailType) {
          case 1:
            return '病历详情';
            break;
          case 2:
            return '问诊单详情';
            break;
          case 3:
            return '病历详情';
            break;
        }
      },
      serviceNumber() {
        return this.$store.state.servicePhone;
      },
      totalPrice() {
        let deciction = this.selectedDecoction == 1 ? this.decoctionMoeny : 0;
        if (this.formData && this.formData.normalPrice) {
          return this.formData.normalPrice + this.expressPrice + deciction;
        } else {
          return 0;
        }
      }
    },
    components: {
      prescriptionPaper,
      questionnaire,
      firstRecord,
      editFirstRecord,
      addressPicker,
      statusDialog
    },
    created() {
      switch (this.detailType) {
        case 1:
          {
            // 未完成的首诊记录获取需要的id
            // if(this.detailStatus == 1) {
            //   this.privateId = this.$route.query.id;
            //   this.docId = this.$route.query.doc_id;
            //   this.recordCreatedTime = this.$route.query.create_time;
            //   this.showBack = false;
            // }else {
            //   this.showBack = true;
            // }

            this.showBack = true;
            // 获取首诊信息数据
            this.$root.post('/getFirstDetail', {
              id: this.$route.query.id
            }).then(data => {
              console.log(data);
              this.patientInfo = {
                pat_username: data.pat_username,
                gender: data.gender,
                birthday: data.birthday,
              }
              this.dataDone = true;
              this.formData = data;
            })
          }
          break;
        case 2:
          {
            this.showBack = true;
            this.pushToDoc = true;
            // 获取问诊单数据
            this.$root.post('/getPatientAnswer', {
              id: this.$route.query.id
            }).then(data => {
              console.log(data);
              this.dataDone = true;
              this.formData = data;
            })
          }
          break;
        case 3:
          {
            // 获取处方数据
            this.$root.post('/getPreDetail', {
              id: this.$route.query.id,
              type: 2,
            }).then(data => {
              this.dataDone = true;
              if (data && data.end_time) {
                let now = new Date().getTime() / 1000;
                this.leftTime = (data.end_time - now) * 1000;
              }
              if (data.address) {
                this.addressData = data.address;
              }
              this.selectedDecoction = data.is_decoction;
              data.normalPrice = data.price / 100 || 0;
              data.normalExpressage = data.expressage / 100 || 0;
              this.expressPrice = data.normalExpressage;
              this.formData = data;
              // 获取代煎费
              this.$root.post('/getDecoctionPrice').then(res => {
                // 代煎费=代煎费单剂价格 * 处方剂量
                this.decoctionMoeny = (res.decoction_price * data.dose) / 100;
                // this.decoctionMoeny = res.decoction_price / 100;
                // 如果已选择过代煎服务，则减去代煎服务的价格，还原药方原价
                if (this.selectedDecoction == 1) {
                  this.formData.normalPrice = this.formData.normalPrice - this.decoctionMoeny;
                }
                // 如果有已选地址回显，则减去运费还原药方原价
                if (this.formData.normalExpressage) {
                  this.formData.normalPrice = this.formData.normalPrice - this.formData.normalExpressage;
                }
              })
              // 获取微信sdk签名
              let url = encodeURIComponent(window.location.href.split('#')[0])
              this.$root.post('/getJsSdk', {
                // url: `${window.location.protocol}//${window.location.host}/`
                url: url
              }).then(data => {
                if (data) {
                  wx.config({
                    debug: this.$store.state.wechatDebug,
                    appId: data.appId,
                    timestamp: data.timestamp,
                    nonceStr: data.nonceStr,
                    signature: data.signature,
                    jsApiList: ['chooseWXPay']
                  });
                }
              })
            })
          }
          break;
      }
    },
    methods: {
      pushTo(data) {
        let _this = this;
        let answerId = this.$route.query.id;
        console.log("pushto")
        console.log(data)
    console.log( data.answer_time)

        // 发送自定义的问诊单卡片
        let conversationType = RongIMLib.ConversationType.PRIVATE;
        // 获取targetId
        let targetId = data.doc_id.toString();
        let msg = new RongIMClient.RegisterMessage.AnswerMessage({
          username: data.pat_username,
          sym_change: data.sym_change,
          create_time: data.answer_time,
          birthday: data.birthday,
          gender: data.gender,
          id:answerId,
        })
        console.log( data.answer_time)
        RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
          onSuccess: function(message) {
            _this.$notify({
              background: '#00848A',
              message: '推送成功'
            });
          },
          onError: function(errorCode) {
            console.log('发送自定义消息失败', errorCode);
          }
        })

      },
      // 倒计时结束后自动将待支付的订单状态变为已失效
      changeOrderStatus() {
        // if(this.formData.order_status == 1) {
        //   this.formData.order_status = 2;
        // }
      },
      // 选择是否代煎
      selectDecoction(type) {
        this.selectedDecoction = type;
      },
      confirmAddress(address) {
        // 获取地址id请求运费数据
        this.addressData = address;
        this.$root.post('/getExpressage', {
          address_id: this.addressData.address_id
        }).then(data => {
          if (data != 0) {
            this.expressPrice = data / 100;
          }
        })
      },
      // 支付订单
      orderPay() {
        if (!this.addressData.address_id) {
          this.$notify('请添加收货地址');
          return;
        }
        console.log(this.selectedDecoction)
        if (this.selectedDecoction == 0 && this.formData.type == 1 && parseFloat(this.formData.paste_price) == 0) {
          this.$notify('请选择是否代煎药方');
          return;
        }
        this.paying = true;
        this.$root.post('/orderPay', {
          order_id: this.formData.order_id,
          address_id: this.addressData.address_id,
          is_decoction: this.selectedDecoction,
        }).then(data => {
          console.log(data);
          let _this = this;
          if (data.status == 1) {
            // 调用微信支付接口
            wx.chooseWXPay({
              timestamp: data.info.timestamp,
              nonceStr: data.info.nonceStr,
              package: data.info.package,
              signType: data.info.signType,
              paySign: data.info.paySign,
              success(res) {
                console.log(res);
                _this.paying = false;
                if (res.errMsg == 'chooseWXPay:ok') {
                  _this.$router.push({
                    path: '/patient/order/success',
                    query: {
                      order_number: _this.formData.number,
                      type: 2,
                      order_id: _this.formData.order_id
                    }
                  })
                } else if (res.errMsg == 'chooseWXPay:cancel') {
                  _this.$notify('您已取消支付');
                } else if (res.errMsg == 'chooseWXPay:fail') {
                  _this.$notify('支付出错，请稍后再试');
                }
              },
              cancel(res) {
                _this.paying = false;
                _this.$notify('您已取消支付');
              },
              fail(res) {
                _this.paying = false;
                _this.$notify('支付出错，请稍后再试');
              },
            })
          } else if (data.status == 2) {
            _this.paying = false;
            _this.invalidOrderShow = true;
          } else {
            _this.paying = false;
            _this.$notify(data.msg);
          }
        })
      },
      back() {
        this.$router.go(-1);
      },
      // 完成填写首诊记录
      finishEditRecord() {
        this.$notify({
          background: '#00848A',
          message: '保存成功'
        });
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      }
    },
    filters: {
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MedicalRecord/detail.vue